import axios from "axios";
import { API } from "./uploads";
import { getSessionId } from "./session";

export async function createReminder(payload) {
  const res = await axios.post(`${API}/reminders`, payload, {
    headers: { "X-Session-Id": getSessionId() },
  });
  return res.data;
}

export async function getReminderForUpload(uploadId) {
  const res = await axios.get(`${API}/reminders/for/${uploadId}`, {
    headers: { "X-Session-Id": getSessionId() },
  });
  return res.data;
}

export async function clearRemindersForUpload(uploadId) {
  const res = await axios.delete(`${API}/reminders/for/${uploadId}`, {
    headers: { "X-Session-Id": getSessionId() },
  });
  return res.data;
}
